export const COLORS = {
  CHRYSOPRASE_BLACK: "#0D352B",
  CHRYSOPRASE_DARKER: "#165848",
  CHRYSOPRASE_DARK: "#268E74",
  CHRYSOPRASE_MEDIUM: "#40BFA0",
  CHRYSOPRASE_PURE: "#48E4BE",
  CHRYSOPRASE_LIGHT: "#8AFFE2",
  CHRYSOPRASE_LIGHTER: "#C8FFF1",
  CHRYSOPRASE_WHITE: "#EDFFFB",

  ONYX_BLACK: "#252828",
  ONYX_DARKER: "#484D4B",
  ONYX_DARK: "#727C7A",
  ONYX_MEDIUM: "#A4ACAA",
  ONYX_PURE: "#C4CDCB",
  ONYX_LIGHT: "#E2E8E8",
  ONYX_LIGHTER: "#EEF4F4",
  ONYX_WHITE: "#F5F8F8",
  ONYX_WHITER: "#FAFCFC",
  WHITE: "#FFFFFF",

  CARNELIAN_DARK: "#B82426",
  CARNELIAN_MEDIUM: "#D8383A",
  CARNELIAN_PURE: "#FF6466",
  CARNELIAN_LIGHT: "#FFA8A9",
  CARNELIAN_LIGHTER: "#FFDDDD",
  CARNELIAN_WHITE: "#FFF8F8",

  BERYL_DARKER: "#BD7100",
  BERYL_DARK: "#EB8D00",
  BERYL_MEDIUM: "#FFAD32",
  BERYL_PURE: "#FFCF88",
  BERYL_LIGHT: "#FFE8C6",
  BERYL_LIGHTER: "#FFF8ED",
  BERYL_WHITE: "#FFF8F8",
};
